import { activitiesCollectionRef } from '../../firebase/collection/collectionReferences';

class UidGeneratorService {
  public static generateActivityUid() {
    return activitiesCollectionRef().doc().id;
  }
}

export default UidGeneratorService;
